import { Box, ButtonBase } from "@mui/material";
import { playMeow } from "../../utils/playMeow";

export const MeowLogo = ({ src, sx }) => (
    <ButtonBase
        aria-label="Miau"
        onClick={playMeow}
        sx={{
            flexShrink: 0,
            borderRadius: "4px",
            "&.Mui-focusVisible": {
                outline: "2px solid currentColor",
                outlineOffset: "4px",
            },
            ...sx,
        }}
    >
        <Box
            component="img"
            src={src}
            alt="Logo"
            sx={{
                height: "20px",
                width: "auto"
            }} />
    </ButtonBase>
);
